<template>
    <div class="my-3 mx-4">
        <b-alert v-if="isVisible" variant="danger" show>
            <h6>{{titleText}}</h6>
            <p>{{actionText}}</p>
        </b-alert>
    </div>
</template>

<script>
    export default {
        name: "ErrorView",
        props: ["visible", "errorValue"],
        data() {
            return {

            }
        },
        computed: {
            isVisible: function () {
                if (this.visible) {
                    return true;
                } else {
                    return false;
                }
            },

            titleText: function() {
                let text = "Sorry! There was a problem completing the request.";

                if(this.errorValue) {
                    //
                }

                return text;
            },

            actionText: function() {
                let text = "Please try again.";
                if(this.errorValue && this.errorValue.message) {
                    text = this.errorValue.message;
                }
                return text;
            }

        }
    }
</script>

<style scoped>

</style>